import script from "./integration-movement-list.vue?vue&type=script&setup=true&lang=js"
export * from "./integration-movement-list.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__